"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftPurchasesResponseAllOfToJSON = exports.GetNftPurchasesResponseAllOfFromJSONTyped = exports.GetNftPurchasesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetNftPurchasesResponseAllOfFromJSON(json) {
    return GetNftPurchasesResponseAllOfFromJSONTyped(json, false);
}
exports.GetNftPurchasesResponseAllOfFromJSON = GetNftPurchasesResponseAllOfFromJSON;
function GetNftPurchasesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftPurchases': (json['nftPurchases'].map(_1.NftPurchaseFromJSON)),
    };
}
exports.GetNftPurchasesResponseAllOfFromJSONTyped = GetNftPurchasesResponseAllOfFromJSONTyped;
function GetNftPurchasesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftPurchases': (value.nftPurchases.map(_1.NftPurchaseToJSON)),
    };
}
exports.GetNftPurchasesResponseAllOfToJSON = GetNftPurchasesResponseAllOfToJSON;
